import React from 'react';
import { constants } from '../../Constants';
import DayPickerInput, { DateUtils } from 'react-day-picker/DayPickerInput';
import moment from 'moment';

import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { editApptTime } from '../../helpers/ConstantID';
export default function EditAppointmentModal(props) {
	const { appointments, appointmentId } = props;
	let appointment = '';
	if (appointments && appointmentId) {
		appointment = appointments.filter((a) => {
			return a.id === appointmentId;
		})[0];
	}
	let date_time = appointment.date_time;
	let selected_date = moment(date_time).format("MMMM D, YYYY").toLocaleString("en-US", { hour: "numeric", })
	let selected_time = moment(date_time).format("HH:mm:ss")
	.toLocaleString("en-US", {
	  hour: "numeric",
	})

	const from = new Date(props.selected_date);
	const to = new Date();
	const modifiers = { start: from, end: to };

	return (
		<React.Fragment>
			<div className="modal-info">
			<div
				className="modal-react counsellor-apt-modal"
				id="modal"
				tabIndex={0}
				onBlur={props.onEditModalClose}
				style={{ width: '518px !important', margin: '134px auto', backgroundColor: '#fff', top: '40%' }}
			>
				<span onClick={props.onCloseModal} className="close-button topright">
					<i className="fa fa-times" aria-hidden="true"></i>
				</span>
				<div className="content">
					<table
						className="table borderless table-responsive w-100 d-block d-md-table"
					>
						<tbody
							className="text-center tableBody"
						>
							<tr>
								<td colSpan={3} className="td-no-border">
								</td>
								
							</tr>
							<tr>
								<td colSpan={3} className="td-no-border">
									<div className="swal2-title">{constants.EDIT_SESSION_TXT}</div>
								</td>
							</tr>
							<tr>
								<td colSpan={3} className="td-no-border sh-pt-0">
									<div className="swal2-content">{`You have a session with ${appointment.patient_name}`}
										<span className="sh-modal-time-color">{`
										at ${moment(appointment.date_time).format('ddd DD MMM YYYY hh:mm:ss A').toLocaleString('en-US', {
											hour: 'numeric',
											hour12: true,
										})}`}
										</span>
									</div>
								</td>
							</tr>
							<tr>
								<td colSpan={3} className="">
								<div className="swal2-content">{constants.CHOOSE_NEW_SCHEDULE_TXT}</div>
								</td>
							</tr>
									<div className="date-selector displayFlex sh-mb-5">
										<div className="InputFromTo" id={editApptTime.sh_cl_Edit_date}>
											<DayPickerInput
												value={props.selected_date || selected_date}
												placeholder="Start date"
												format="LL"
												formatDate={formatDate}
												parseDate={parseDate}
												id="stardDate"
												dayPickerProps={{
													disabledDays: { before: new Date() },
												    modifiers,
												}}
												onDayChange={props.onDateChange}
											/>
										</div>
										<div className="">
											<div className="select-time--container">
												<select
													id="select-time"
													style={{
														marginTop: '0px !important',
														marginLeft: '10px !important',
														width: '100%',
													}}
 													onChange={props.onTimeChange}
													value={props.selected_time || selected_time || '00:00:00'}
												>
													<option value="00:00:00">12:00 AM</option>
													<option value="01:00:00">1:00 AM</option>
													<option value="02:00:00">2:00 AM</option>
													<option value="03:00:00">3:00 AM</option>
													<option value="04:00:00">4:00 AM</option>
													<option value="05:00:00">5:00 AM</option>
													<option value="06:00:00">6:00 AM</option>
													<option value="07:00:00">7:00 AM</option>
													<option value="08:00:00">8:00 AM</option>
													<option value="09:00:00">9:00 AM</option>
													<option value="10:00:00">10:00 AM</option>
													<option value="11:00:00">11:00 AM</option>
													<option value="12:00:00">12:00 PM</option>
													<option value="13:00:00">1:00 PM</option>
													<option value="14:00:00">2:00 PM</option>
													<option value="15:00:00">3:00 PM</option>
													<option value="16:00:00">4:00 PM</option>
													<option value="17:00:00">5:00 PM</option>
													<option value="18:00:00">6:00 PM</option>
													<option value="19:00:00">7:00 PM</option>
													<option value="20:00:00">8:00 PM</option>
													<option value="21:00:00">9:00 PM</option>
													<option value="22:00:00">10:00 PM</option>
													<option value="23:00:00">11:00 PM</option>
												</select>
												<p className="pst">{}</p>
											</div>
										</div>
									</div>
							<tr>
								<td colSpan={3} className="td-no-border">
									<div className="sh-btn-box">
										<button id={editApptTime.sh_cl_edit_cancel} className="sh-gnrl-btn sh-gnrl-cancel-btn" onClick={props.onCloseModal}>
											{constants.CANCEL_TXT}
										</button>
										<button
											id={editApptTime.sh_cl_edit_submit}
											type="button"
											className="sh-gnrl-btn sh-gnrl-sumit-btn"
											onClick={props.editAppointment}
										>
											{constants.SUBMIT_TEXT}
										</button>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			</div>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/components/EditAppointmentModal/index.js